//open material's submenu for each item when clicked
$('.f-menu .expand-menu').click(function() {
  var thisSubmenu = $(this).siblings('ul');
  var thisIcon = $(this).children('.fa-chevron-down');
  thisSubmenu.toggle();
  thisIcon.toggleClass('opened');
});

//open the current page's submenu on the side menu
$(document).ready(function() {
  var href = document.location.href;
  var pageName = href.slice(href.lastIndexOf('/') + 1, href.indexOf('.html'));

  if (pageName == 'feedback') {
    $('.fa-envelope').addClass('active');
  }

  if (pageName != '') {
    $('#submenu-' + pageName).siblings('.expand-menu').click();
  }
});


// WEBPACK FOOTER //
// ./src/assets/fabricator/scripts/f-menu.js